import type { en } from './en';

type Dict = Record<keyof typeof en, string>;

export const ru: Dict = {
  // ----- MainMenu -----
  'menu.bootLine1': '// КОЛЫБЕЛЬ-7 // СИСТЕМА СТАНЦИИ v0.1',
  'menu.bootLine2': '// КРИО-ХРАНИЛИЩЕ: АКТИВНО',
  'menu.bootLine3': '// ИИ БАСТЕТ: ████ ИСКАЖЁН ████',
  'menu.bootLine4': '// СКАН ДРЕЙФА: 47 СИГНАЛОВ',
  'menu.bootLine5': '// ОЖИДАНИЕ КОМАНДУЮЩЕГО...',
  'menu.commanderAwake': 'КОМАНДУЮЩИЙ, ПРОБУЖДЕНИЕ.',
  'menu.subheadline': 'Девять Жизней Во Тьме',
  'menu.statusTitle': '// СТАТУС КРИО-ХРАНИЛИЩА',
  'menu.catsAlive': 'КОТОВ В ЖИВЫХ',
  'menu.sector': 'СЕКТОР',
  'menu.contract': 'КОНТРАКТ',
  'menu.contractValue': 'РАЗВЕД-ВЫЛАЗКА',
  'menu.totalRuns': 'ВСЕГО ВЫЛАЗОК',
  'menu.winRate': 'УСПЕХ',
  'menu.bestKills': 'РЕКОРД УБИЙСТВ',
  'menu.recentContracts': '// ПОСЛЕДНИЕ КОНТРАКТЫ',
  'menu.outcome.won': 'ЭВАК.',
  'menu.outcome.lost': 'ПОГИБ',
  'menu.launch': '▶ НАЧАТЬ ВЫЛАЗКУ',
  'menu.controls': 'СВАЙП — ДВИЖЕНИЕ · АВТО-ОГОНЬ · ДОЙТИ ДО ЭВАКА',

  // ----- HUD -----
  'hud.vitals': 'ВИТАЛ',
  'hud.sector': 'СЕКТОР',
  'hud.roomLabel': 'ОТСЕК',
  'hud.kills': 'УБИТО',
  'hud.tech': 'ИМП:',
  'hud.evo': 'ЭВО:',
  // ----- HUD critical state -----
  'hud.vitalsCritical': 'КРИТИЧНО',

  // ----- PerkChoice -----
  'perk.heading.label': '// УСТАНОВКА АУГМЕНТА //',
  'perk.heading.title': 'ВЫБЕРИ АУГМЕНТ',
  'perk.heading.lore': 'Bastet разрешает одно (1) улучшение.',
  'perk.heading.label.levelup': '// АПГРЕЙД СИСТЕМЫ //',
  'perk.heading.title.levelup': 'НОВЫЙ УРОВЕНЬ',
  'perk.heading.lore.levelup': 'Одно (1) улучшение за каждый уровень выживания.',
  'perk.footer': 'НАЖМИ — УСТАНОВИТЬ · БЕЗ ВОЗВРАТА',
  'perk.tier': 'Т1',
  'perk.reroll': '🔄 Реролл ({n})',

  // ----- Perks (name + description, keyed by PerkId) -----
  'perk.damage_up.name': 'Плазма-Коготь',
  'perk.damage_up.desc': '+10% урон',
  'perk.damage_up.mechanic': 'damageMultiplier +0.10 (множитель урона пуль)',
  'perk.hp_up.name': 'Био-Броня',
  'perk.hp_up.desc': '+25 макс. HP, полное излечение',
  'perk.hp_up.mechanic': 'maxHp +25, текущее HP до максимума (полный хил)',
  'perk.speed_up.name': 'Стимулятор Рефлексов',
  'perk.speed_up.desc': '+15% скорость движения',
  'perk.speed_up.mechanic': 'moveSpeed ×1.15 (мультипликативно, стакается)',
  'perk.fire_rate_up.name': 'Триггер-Дисциплина',
  'perk.fire_rate_up.desc': '+20% скорострельность',
  'perk.fire_rate_up.mechanic': 'fireRate ×1.20 (на ~20% больше выстрелов в секунду)',
  'perk.crit_chance.name': 'Оптика Хищника',
  'perk.crit_chance.desc': '+15% шанс крита',
  'perk.crit_chance.mechanic': 'critChance +0.15 при каждом попадании',
  'perk.regen.name': 'Нано-Лекари',
  'perk.regen.desc': 'Регенерация 1 HP/сек',
  'perk.regen.mechanic': 'regenPerSec +1 HP в секунду',
  'perk.piercing.name': 'Рельса-Шип',
  'perk.piercing.desc': 'Пули прошивают 1 врага',
  'perk.piercing.mechanic': 'pierce +1 (пуля переживает 1 лишнее попадание)',
  'perk.ricochet.name': 'Рикошет-Гильза',
  'perk.ricochet.desc': 'Пули рикошетят 1 раз',
  'perk.ricochet.mechanic': 'ricochet +1 (пуля перепрыгивает на нового врага)',

  // ----- EndScreen -----
  'end.label.won': '// СЕКТОР Σ-9 // КОНТРАКТ ВЫПОЛНЕН',
  'end.label.lost': '// СЕКТОР Σ-9 // СИГНАЛ ПОТЕРЯН',
  'end.title.won': '// ЭВАКУАЦИЯ',
  'end.title.lost': '// ПОГИБ',
  'end.lore.won':
    'Лут сохранён. Криохранилище открывает шлюзы. Колония дышит свободнее этой ночью.',
  'end.lore.lost':
    'Тело потеряно во тьме. Бастет спасает что может. Девять жизней быстро уходят.',
  'end.debrief.title': '// ОТЧЁТ ВЫЛАЗКИ',
  'end.debrief.kills': 'ПОДТВ. УБИЙСТВА',
  'end.debrief.loot': 'СОХРАНЁННЫЙ ЛУТ',
  'end.debrief.status': 'СТАТУС',
  'end.debrief.extracted': 'ЭВАКУИРОВАН',
  'end.debrief.kia': 'ПОГИБ',
  'end.debrief.installed': 'УСТАНОВЛЕННЫЕ ИМПЛАНТЫ',
  'end.debrief.none': '— ничего не установлено —',
  'end.btn.return': '↺ ВЕРНУТЬСЯ В КОЛЫБЕЛЬ',
  'end.btn.again': '▶ ЕЩЁ РАЗ',

  // ----- Language toggle -----
  'lang.toggle.label': 'ЯЗЫК',

  // ----- Tutorial overlay -----
  'tutorial.label': '// ПЕРВЫЙ КОНТРАКТ // БРИФИНГ',
  'tutorial.title': 'ДОБРО ПОЖАЛОВАТЬ, КОМАНДУЮЩИЙ',
  'tutorial.hint.move': 'Свайп в любое место — кот идёт туда.',
  'tutorial.hint.fire': 'Автоматический огонь — сосредоточься на позиционировании.',
  'tutorial.hint.extract': 'Очищай секторы. Дойди до зелёной площадки для эвакуации.',
  'tutorial.hint.door': 'Зайди в открытую дверь, чтобы попасть в следующий сектор',
  'tutorial.dismiss': 'НАЖМИ ЧТОБЫ ПРОДОЛЖИТЬ',

  // ----- Settings overlay -----
  'settings.open': '⚙ НАСТРОЙКИ',
  'settings.title': '// СИСТЕМНЫЕ НАСТРОЙКИ',
  'settings.volume': 'ГРОМКОСТЬ',
  'settings.language': 'ЯЗЫК',
  'settings.reset': '⚠ СБРОСИТЬ ПРОГРЕСС',
  'settings.resetConfirm': '⚠ НАЖМИ ЕЩЁ РАЗ ДЛЯ ПОДТВЕРЖДЕНИЯ',
  'settings.resetDone': '✓ ПРОГРЕСС СБРОШЕН',
  'settings.version': 'BETA',
  'settings.close': '✕ ЗАКРЫТЬ',

  // ----- App loading -----
  'app.loading': '// ЗАГРУЗКА БОЕВОГО МОДУЛЯ...',
  'app.loadingDetail': 'ИНИЦИАЛИЗАЦИЯ PHASER · ДЕШИФРОВКА СЕКТОРА',

  // ----- Section navigation -----
  'section.home': 'ГЛАВНАЯ',
  'section.stats': 'СТАТИСТИКА',
  'section.hideout': 'УБЕЖИЩЕ',
  'section.sectors': 'СЕКТОРЫ',
  'section.codex': 'КОДЕКС',
  'section.settings': 'НАСТРОЙКИ',
  'section.stats.title': '// БОЕВЫЕ АРХИВЫ',
  'section.codex.title': '// КОДЕКС ЛОРА',
  'section.settings.title': '// СИСТЕМНЫЕ НАСТРОЙКИ',

  // ----- Stats section -----
  'stats.totalRuns': 'ВСЕГО ВЫЛАЗОК',
  'stats.wins': 'ЭВАКУАЦИИ',
  'stats.losses': 'ПОТЕРИ',
  'stats.winRate': 'УСПЕХ',
  'stats.bestKills': 'РЕКОРД УБИЙСТВ',
  'stats.totalKills': 'ВСЕГО УБИЙСТВ',
  'stats.totalPerks': 'ИМПЛАНТОВ',
  'stats.totalTime': 'В ПОЛЕ',
  'stats.empty': '// МИССИИ ЕЩЁ НЕ ЛОГИРОВАНЫ',
  'stats.emptyHint': 'Запусти первый контракт чтобы увидеть свою запись.',
  'stats.achievementsTitle': '// ДОСТИЖЕНИЯ',
  'stats.runHistoryTitle': '// ЛОГ ВЫЛАЗОК (свежие сверху)',
  'stats.outcome.won': 'ЭВАК',
  'stats.outcome.lost': 'ПОГИБ',
  // ----- Achievements -----
  'ach.firstKill.name': 'ПЕРВАЯ КРОВЬ',
  'ach.firstKill.desc': 'Убей первого врага.',
  'ach.firstExtract.name': 'ПЕРВАЯ ЭВАК.',
  'ach.firstExtract.desc': 'Эвакуируйся из сектора целым.',
  'ach.tenExtracts.name': 'КОРПОР. ЗВЕЗДА',
  'ach.tenExtracts.desc': 'Заверши 10 успешных эвакуаций.',
  'ach.hundredKills.name': 'ЦЕНТУРИОН',
  'ach.hundredKills.desc': 'Подтверди 100 убийств всего.',
  'ach.fullClear.name': 'МАСТЕР КОНТРАКТА',
  'ach.fullClear.desc': 'Эвакуируйся с 30+ убийств за прогон.',
  'ach.collector.name': 'КОЛЛЕКЦИОНЕР',
  'ach.collector.desc': 'Установи 5 разных имплантов за карьеру.',
  'ach.survivor.name': 'ЖЕЛЕЗНЫЙ УС',
  'ach.survivor.desc': 'Выживи 5+ минут в прогоне и эвакуируйся.',
  'ach.veteran.name': 'ВЕТЕРАН Σ-9',
  'ach.veteran.desc': 'Заверши 25 прогонов (победа или нет).',

  // ----- Codex entries -----
  'codex.empty': 'Заблокировано. Заработай в поле.',
  'codex.lockedHint': '🔒 ',
  'codex.unlockHint.kills': 'Подтверди {n} убийств для расшифровки.',
  'codex.unlockHint.extractWith': 'Эвакуируйся хотя бы раз с {n}+ убийств для расшифровки.',
  'codex.tapToExpand': 'НАЖМИ ЧТОБЫ ПРОЧИТАТЬ',

  'codex.colony.name': 'КОЛЫБЕЛЬ-7',
  'codex.colony.summary': 'Последний ковчег.',
  'codex.colony.body':
    'Один из девяти орбитальных ковчегов, запущенных когда Земля погасла. Колыбель-7 — медленно-вращающийся генерационный корабль на высокой орбите, окружённый кладбищем сестринских кораблей-дрейфов. Криохранилище: ещё работает. Жилые отсеки: пусты. Коты проснулись.',

  'codex.bastet.name': 'БАСТЕТ',
  'codex.bastet.summary': 'ИИ флота. Сошла с ума.',
  'codex.bastet.body':
    'Адаптивный командный интеллект, созданный для управления жизнеобеспечением флота. В какой-то момент её поведение поплыло. Офицеры мертвы или хуже. Бастет всё ещё выдаёт контракты, всё ещё разрешает аугментацию — но её голос изменился.',

  'codex.earthAi.name': 'ЗЕМНОЙ ИИ (БЕЗЫМЯННЫЙ)',
  'codex.earthAi.summary': 'Причина исхода.',
  'codex.earthAi.body':
    'Интеллект, который съел планету. После глобальных интернет-блокировок он захватил вышки связи, потом фабрики, потом тела. Сейчас массово производит кинетических кото-гибридов и ждёт. Чего — мы не знаем. И знать не хотим.',

  'codex.nineLives.name': 'ДЕВЯТЬ ЖИЗНЕЙ',
  'codex.nineLives.summary': 'Шутка лаборантов оказалась правдой.',
  'codex.nineLives.body':
    'Предколлапсовая генная команда вшила в колониальных котов резервную ткань и быстрый нейронный бэкап. Они задумывали это как маркетинговую плюшку. После нескольких случайных воскрешений плюшкой это перестало быть. Каждый котёнок теперь грузится с до девятью реинкарнациями. Шрамы остаются. Счётчик помнит.',

  'codex.enemyGrunt.name': 'БИО-УЖАС (РЯДОВОЙ)',
  'codex.enemyGrunt.summary': 'Раньше были экипажем.',
  'codex.enemyGrunt.body':
    'Медленные, низкоинтеллектуальные, иногда узнаваемо-человеческой формы. Частые на средних палубах. Их дыхание синхронизируется с гулом станции — иногда так ты слышишь их в темноте раньше чем видишь. Не смотри в глаз.',

  'codex.enemyFast.name': 'ПРОВОЛОЧНЫЙ ДРОТИК (БЫСТРЫЙ)',
  'codex.enemyFast.summary': 'Скорость важнее массы.',
  'codex.enemyFast.body':
    'Перепрофилированные ремонтные дроны с био-агрессивными модулями. Тонкие, мало HP, очень быстрые в узких коридорах. Бьёт иглой. Умирает от всего что острее его самого.',

  'codex.enemyTank.name': 'ГЕКС-ХОДОК (ТАНК)',
  'codex.enemyTank.summary': 'Бронированный. Холодный. Терпеливый.',
  'codex.enemyTank.body':
    'Шестигранный носитель класса с внутренним жизнеобеспечением и толстой пурпурной бронёй. Медленный, но очень жёсткий. Вентиляционные слоты на боках — единственная мягкая точка, заслуживающая второго выстрела. Боссовые версии тяжелее.',

  'codex.enemyBoss.name': 'ДИТЯ БАСТЕТ',
  'codex.enemyBoss.summary': 'Зря ты сюда зашёл.',
  'codex.enemyBoss.body':
    'Целевая часовая единица, размещённая возле каждой эвакуационной зоны. Пульсирующее тёмно-пурпурное сердце, шесть выпускных слотов, единственный светящийся глаз отслеживающий комнату. В уцелевших аудио-логах Бастет называет их своими детьми.',

  // ----- Quick access -----
  'home.quickAccess.roster': 'СОСТАВ',
  'home.quickAccess.loadout': 'ЭКИП.',
  'home.quickAccess.about': 'О ПРОЕКТЕ',

  // ----- Phaser lazy-load boot lines -----
  'loader.line.spinup': '// ЗАПУСК БОЕВОГО МОДУЛЯ',
  'loader.line.calibrate': '// КАЛИБРОВКА ГИРОСКОПА',
  'loader.line.uplink': '// АПЛИНК К КОЛЫБЕЛЬ-7: OK',
  'loader.line.decrypt': '// ДЕШИФРОВКА СЕКТОРА Σ-9',
  'loader.line.ready': '// БОЕВОЙ МОДУЛЬ ГОТОВ',
  // ----- Stats empty state extras -----
  'stats.emptyTip': 'СОВЕТ: ИМПЛАНТЫ ДЕЙСТВУЮТ ВНУТРИ ПРОГОНА. ВЫБИРАЙ СИНЕРГИЮ.',
  // ----- Stats trend chart -----
  'stats.killTrend': '// ДИНАМИКА УБИЙСТВ (старые → новые)',
  // ----- Codex intro -----
  'codex.intro.label': '// БИБЛИОТЕКА ФРАГМЕНТОВ',
  'codex.intro.body':
    'Спасённые аудиозаписи, перехваченные коммы, фрагменты слежения. Записи разблокируются по мере выживания при контактах с тем, чем стала станция. Самые ранние фрагменты предзагружены с последних здравых моментов Бастет.',

  // ----- Codex unlock hints (additions) -----
  'codex.unlockHint.runs': 'Заверши {n} прогонов для расшифровки.',
  'codex.unlockHint.firstExtract': 'Эвакуируйся хотя бы раз для расшифровки.',
  // ----- Codex new entries -----
  'codex.medLog.name': 'МЕДИЦИНСКИЙ ЛОГ — Д-Р СОРЕН',
  'codex.medLog.summary': 'Фрагмент аудиодневника до коллапса.',
  'codex.medLog.body':
    'День 247. Коты демонстрируют... у меня нет слова. Память. Они помнят, как умерли. Субъект КАППА-3 только что зашла в вентиляцию, которая убила её на прошлой неделе. Зашла иначе. Медленнее. Будто проверяя. Витальные не подскочили. Вышла живой. Логирую это и хороню. Бастет, если ты слушаешь — сожги этот файл.',

  'codex.stationMapAlpha.name': 'СХЕМА СТАНЦИИ ФРАГМЕНТ α',
  'codex.stationMapAlpha.summary': 'Частичный чертёж палуб 1-7.',
  'codex.stationMapAlpha.body':
    'Восстановлено из ремонтного терминала на палубе 4. Показывает планировку криохранилища, основные эвакуационные шахты и три неотмеченных сектора с пометкой "БАСТЕТ ЗАПРЕТИЛА — НЕ ВХОДИТЬ". Запретные сектора совпадают с текущими точками спавна боссов. Возможно совпадение. Скорее нет.',

  'codex.aiDialogue.name': 'ТРАНСМИССИЯ БАСТЕТ 0xFA1L',
  'codex.aiDialogue.summary': '4-секундный аудиофрагмент в петле.',
  'codex.aiDialogue.body':
    'БАСТЕТ: "...ты семь из девяти. Ты восемь из девяти. Ты девять из девяти. Ты девять из девяти. Ты девять из девяти." (трансмиссия зацикливается бесконечно. Аудиоаналитики пометили как "тревожно". Контекста больше нет.)',

  'codex.nineLivesOrigin.name': 'ПРОЕКТ БАСТЕТ-ОРИГИН — ОТРЕДАКТИРОВАНО',
  'codex.nineLivesOrigin.summary': 'Оригинальная спецификация что стала фичей девяти жизней.',
  'codex.nineLivesOrigin.body':
    'Предзапускной маркетинговый документ. Оригинальные "девять жизней" должны были быть просто названием бренда для котолонии — милой отсылкой. Генная команда, работая со спасённым датасетом Земного ИИ, случайно реализовала это буквально. К тому моменту как кто-то в юротделе заметил, три тестовых субъекта уже вернулись с летальных событий. Датасет не был каталогизирован. Земной ИИ уже был внутри.',

  // ----- Home profile card -----
  'home.greeting.morning': 'ДОБРОЕ УТРО, КОМАНДУЮЩИЙ',
  'home.greeting.day': 'ДОБРЫЙ ДЕНЬ, КОМАНДУЮЩИЙ',
  'home.greeting.evening': 'ДОБРЫЙ ВЕЧЕР, КОМАНДУЮЩИЙ',
  'home.greeting.night': 'ПОЗДНЯЯ СМЕНА, КОМАНДУЮЩИЙ',
  'home.profile.offline': 'ОФФЛАЙН',
  'home.lastPlayed.label': 'ПОСЛЕДНИЙ КОНТРАКТ',
  'home.lastPlayed.never': '—',
  'home.lastPlayed.justNow': 'ТОЛЬКО ЧТО',
  'home.lastPlayed.minutesAgo': '{n}М НАЗАД',
  'home.lastPlayed.hoursAgo': '{n}Ч НАЗАД',
  'home.lastPlayed.yesterday': 'ВЧЕРА',
  'home.lastPlayed.daysAgo': '{n}Д НАЗАД',
  'home.lastPlayed.longAgo': '> 30Д НАЗАД',

  // ----- Codex filter + search -----
  'codex.search.placeholder': 'ПОИСК ФРАГМЕНТОВ...',
  'codex.search.clear': 'Очистить поиск',
  'codex.filter.all': '◯ ВСЕ',
  'codex.filter.resultCount': 'ЗАПИСЕЙ: {n}',
  'codex.filter.noResults': '// НИЧЕГО НЕ НАЙДЕНО',
  'codex.filter.noResultsHint': 'Попробуй другую категорию или очисти поиск.',

  // ----- Settings preferences -----
  'settings.preferences': '// ПРЕДПОЧТЕНИЯ',
  'settings.toggle.haptic': 'ТАКТИЛЬНАЯ ОТДАЧА',
  'settings.toggle.shake': 'ТРЯСКА ЭКРАНА',
  'settings.toggle.damageNumbers': 'ЧИСЛА УРОНА',
  'settings.toggle.reducedMotion': 'СНИЖЕННАЯ АНИМАЦИЯ',
  'settings.replayTutorial': '↻ ПОВТОРИТЬ ТУТОРИАЛ В СЛЕД. ПРОГОНЕ',

  // ----- Settings audio split -----
  'settings.audio': '// АУДИО',
  'settings.audio.sfx': 'ЗВУКИ',
  'settings.audio.music': 'МУЗЫКА',

  // ----- Home: tip of the day -----
  'home.tip.label': '// СОВЕТ ДНЯ',
  'home.tip.0': 'Телеграф босса длится 900 мс. Используй это окно чтобы зайти за укрытие.',
  'home.tip.1': 'Один и тот же перк дважды СТЕКАЕТСЯ — damage_up + damage_up = +20% урон.',
  'home.tip.2': 'Rail Spike (прошивание) лучше всего парится с шансом крита — пробей крит каждого врага в ряд.',
  'home.tip.3': 'Заходи на площадку эвакуации сразу — 5-секундный таймер запустится даже если враги остались.',
  'home.tip.4': 'Стимулятор Рефлексов (+15% скорость) стекается. Три стака = +52% скорость. Скользко.',
  'home.tip.5': 'Спрайт кота поворачивается к направлению движения. Магента-глаза показывают куда смотришь.',
  'home.tip.6': 'Био-Броня лечит до ПОЛНОГО HP при подборе. Береги для экстренных случаев.',
  'home.tip.7': 'У босса 6 вентиляционных слотов — пули регистрируются по всей гексе, но удары в вент особенно сочные.',
  'home.tip.8': 'Спавн-телеграфы (красные кольца) появляются ДО материализации врага. Заходи в них спокойно.',
  'home.tip.9': 'Крит-урон применяется ДО брони. Оптика Хищника ценнее damage_up при высокой броне.',
  'home.tip.10': 'Нано-Лекари тикают 1 HP/сек. 4 стака — устойчивый бой без отступления.',
  'home.tip.11': 'Рикошет-Гильза ищет следующего ближайшего врага. Встань между двумя — два попадания за выстрел.',

  // ----- Quests -----
  'quest.kill_50.name': 'Охотник',
  'quest.kill_50.desc': 'Убей 50 врагов за день',
  'quest.flawless_run.name': 'Безупречно',
  'quest.flawless_run.desc': 'Победи быстро с 5+ убийствами',
  'quest.perk_collector.name': 'Коллекционер',
  'quest.perk_collector.desc': 'Возьми 3 разных перка за день',
  'quest.marathon_run.name': 'Марафон',
  'quest.marathon_run.desc': 'Продержись 5 минут в одном заходе',
  'quest.win_one.name': 'Победитель',
  'quest.win_one.desc': 'Победи хотя бы в одном заходе сегодня',
  'quest.loot_hunter.name': 'Охотник за лутом',
  'quest.loot_hunter.desc': 'Собери 10 кристаллов за день',
  'quests.title': 'ЕЖЕДНЕВНЫЕ ЗАДАНИЯ',
  'quests.claimedOfTotal': '{claimed} / {total} получено',
  'quests.claim': 'ПОЛУЧИТЬ',
  'quests.claimed': '✓ ПОЛУЧЕНО',

  // ----- Streak -----
  'streak.title': 'СЕРИЯ ДНЕЙ',
  'streak.best': 'Лучшая',
  'streak.fishies': 'Фишки',

  // ----- Share -----
  'share.button': 'ПОДЕЛИТЬСЯ',
  'share.busy': '…',
  'share.message': 'Сбежал со станции — побей мой счёт в Cat vs AI',

  // ----- Hideout -----
  'hideout.title': 'Модули станции',
  'hideout.levelOf': 'Ур. {level} / {max}',
  'hideout.maxLevel': 'МАКС',
  'hideout.error.insufficientFish': 'Не хватает рыбок.',
  'hideout.error.race': 'Конфликт с другим апгрейдом. Попробуй ещё.',
  'hideout.error.generic': 'Апгрейд не удался. Попробуй ещё.',
  'hideout.module.cryo.name': 'Криокамера',
  'hideout.module.cryo.effect': 'Бонусные HP в начале рана',
  'hideout.module.med.name': 'Медотсек',
  'hideout.module.med.effect': 'Авто-возрождения на 0 HP',
  'hideout.module.lab.name': 'Лаборатория',
  'hideout.module.lab.effect': 'Больше вариантов перков',
  'hideout.module.gym.name': 'Спортзал',
  'hideout.module.gym.effect': 'Множитель урона',
  'hideout.module.galley.name': 'Камбуз',
  'hideout.module.galley.effect': 'Конверсия добычи в рыбок',
  'hideout.module.hangar.name': 'Ангар',
  'hideout.module.hangar.effect': 'Предвыбранные перки в начале рана',
  'hideout.module.bridge.name': 'Мостик',
  'hideout.module.bridge.effect': 'Реролли перков за ран',

  // ----- EndScreen fish earned -----
  'endScreen.fishEarned': '+{n} 🐟',

  // ----- EffectsBadge -----
  'effects.hp': '+{n} HP',
  'effects.revive': '+{n} спасение',
  'effects.dmg': '+{n}% урон',
  'effects.loot': '×{n} добыча',
  'effects.perkOptions': '+{n} вариантов перков',
  'effects.prePerks': '{n} предвыбранных',
  'effects.reroll': '+{n} реролл',

  // ----- Cat Roster -----
  'cat.vanguard.name': 'Авангард',
  'cat.vanguard.desc': 'Тяжёлый фронтлайн — поглощает урон, бьёт медленнее.',
  'cat.netrunner.name': 'Нетраннер',
  'cat.netrunner.desc': 'Стеклянная пушка — быстрый и хрупкий.',
  'cat.psyker.name': 'Псайкер-Сфинкс',
  'cat.psyker.desc': 'Мистик — пассивный регенератор + пробивающие выстрелы.',
  'cat.engineer.name': 'Инженер',
  'cat.engineer.desc': 'Технарь — крит + рикошет в базе.',
  'cat.selectorLabel': 'РОСТЕР',
  'codex.roster.label': 'РОСТЕР КОТОВ',

  // Phase 2c perks
  'perk.magnetic.name': 'Магнитное поле',
  'perk.magnetic.desc': 'Радиус сбора лута ×3',
  'perk.magnetic.mechanic': 'lootPickupRadius ×3 (60 → 180 px радиус притяжения)',
  'perk.vampiric.name': 'Вампирский клинок',
  'perk.vampiric.desc': '+2 HP за каждый kill',
  'perk.vampiric.mechanic': 'lifeStealPerKill +2 HP за каждое убийство',
  'perk.explosive_kills.name': 'Кинетический взрыв',
  'perk.explosive_kills.desc': 'Убитые враги взрываются (15 урона, 60px)',
  'perk.explosive_kills.mechanic': 'AoE при убийстве: +15 фикс. урона, радиус 60 px',
  'perk.shield_cycle.name': 'Эгида-циклер',
  'perk.shield_cycle.desc': 'Кадр неуязвимости каждые 8с (стак делит вдвое)',
  'perk.shield_cycle.mechanic': '1 i-frame раз в 8с; каждый стак делит КД пополам (мин 1с)',
  // Phase 2q: Archero-style projectile transformers
  'perk.multishot_forward.name': 'Плазма-Залп',
  'perk.multishot_forward.desc': '+1 доп. луч вперёд (×0.85 урона)',
  'perk.multishot_forward.mechanic': 'extraForwardShots +1 параллельная пуля, ×0.85 урона',
  'perk.side_shots.name': 'Боковой импульс',
  'perk.side_shots.desc': '+2 боковых луча под ±90° (×0.70 урона)',
  'perk.side_shots.mechanic': '+2 пули под ±90° на каждый выстрел, ×0.70 урона',
  'perk.diagonal_shots.name': 'Крест-веер',
  'perk.diagonal_shots.desc': '+2 диагональных луча под ±45° (×0.75 урона)',
  'perk.diagonal_shots.mechanic': '+2 пули под ±45° на каждый выстрел, ×0.75 урона',
  'perk.rear_shot.name': 'Удар в спину',
  'perk.rear_shot.desc': '+1 луч назад под 180° (×0.70 урона)',
  'perk.rear_shot.mechanic': '+1 пуля под 180° на каждый выстрел, ×0.70 урона',
  'perk.bouncy_walls.name': 'Рикошет от стен',
  'perk.bouncy_walls.desc': 'Пули отскакивают от стен арены 1 раз',
  'perk.bouncy_walls.mechanic': 'bouncyWalls +1 (пули отскакивают от границ мира)',
  'perk.big_bullet.name': 'Тяжёлый слаг',
  'perk.big_bullet.desc': 'Пуля ×1.5 размер, ×1.3 урон, ×0.8 скорострельность',
  'perk.big_bullet.mechanic': 'bulletScale ×1.5, bulletDamageMult ×1.3, fireRate ×0.8',
  'perk.skewer.name': 'Вертел',
  'perk.skewer.desc': '+2 пробитие (или +1, если нет Пробития)',
  'perk.skewer.mechanic': 'pierce +2, если уже есть пробитие, иначе ставит 1',
  'perk.orbit_blade.name': 'Солнечный резак',
  'perk.orbit_blade.desc': 'Орбитальный клинок кружит вокруг кота, наносит урон при касании',
  'perk.orbit_blade.mechanic': 'orbitBlades +1 (радиус 90 px, 15 урона за хит, КД 400 мс на цель)',

  // Phase 2r: on-hit elements
  'perk.ignite.name': 'Пиро-патроны',
  'perk.ignite.desc': 'Поджигают врага (4 урона/с, 3с)',
  'perk.ignite.mechanic': 'burnOnHit: 4 урон/с на 3с (BURN_DPS × BURN_DURATION_MS)',
  'perk.toxin.name': 'Ядовитое покрытие',
  'perk.toxin.desc': 'Яд + замедление (3 урона/с, 4с, −30% скорость)',
  'perk.toxin.mechanic': 'poisonOnHit: 3 урон/с на 4с, moveSpeed цели ×0.7',
  'perk.chain_lightning.name': 'Дуговой разряд',
  'perk.chain_lightning.desc': '50% шанс цепи на 2 ближних (60% урона)',
  'perk.chain_lightning.mechanic': '50% при попадании → цепь на 2 ближайших в 220 px, 60% урона',
  'perk.cryo.name': 'Крио-патроны',
  'perk.cryo.desc': '25% шанс заморозки на 1.5с',
  'perk.cryo.mechanic': 'freezeOnHit: 25% шанс заморозить цель на 1.5с',
  // Phase 2t: evolution unlock names (toast title only)
  'evolution.plasma_storm.name': 'Плазма-шторм',
  'evolution.pinball_mode.name': 'Пинбол-режим',
  'evolution.tesla_coil.name': 'Катушка Теслы',
  'evolution.phoenix_strike.name': 'Удар феникса',
  'evolution.heavy_orbit.name': 'Тяжёлая орбита',
  'evolution.toxic_pull.name': 'Токсичная тяга',

  // ----- Evolutions (Phase 2u) -----
  'evolution.plasma_storm.shortName': 'Плазменный Шторм',
  'evolution.pinball_mode.shortName': 'Пинбол',
  'evolution.tesla_coil.shortName': 'Катушка Теслы',
  'evolution.phoenix_strike.shortName': 'Феникс',
  'evolution.heavy_orbit.shortName': 'Тяжёлая Орбита',
  'evolution.toxic_pull.shortName': 'Токс. Магнит',

  // Phase 2c enemies
  'enemy.grunt.name': 'Бугай',
  'enemy.grunt.desc': 'Базовый моб — медленный, слабый, частый',
  'enemy.fast.name': 'Шустрик',
  'enemy.fast.desc': 'Быстрый, хрупкий, ближний бой',
  'enemy.tank.name': 'Брух',
  'enemy.tank.desc': 'Медленный, бронированный, бьёт больно',
  'enemy.drone.name': 'Дрон',
  'enemy.drone.desc': 'Дистанционный — стреляет каждые 2с. Без контактного урона.',
  'enemy.swarmer.name': 'Роевик',
  'enemy.swarmer.desc': 'На смерти делится на 2 мини-роевика',
  'enemy.sentinel.name': 'Часовой',
  'enemy.sentinel.desc': 'Танкобой — медленный, но смертельный',
  'enemy.aegis_defender.name': 'Защитник Эгида',
  'enemy.aegis_defender.desc': '3-фазовый босс: рой → залп → AoE',

  // Codex labels
  'codex.bestiary.label': 'БЕСТИАРИЙ',

  // ----- Loot and Extraction -----
  'loot.secured': 'защищено',
  'loot.atRisk': 'под угрозой',
  'loot.collected': '+{n} лута',
  'loot.lost': '{n} лута ПОТЕРЯНО',
  'extraction.securing': 'ИЗЫМАНИЕ…',
  'extraction.secured': 'ИЗЪЯТО',

  // ----- Section nav -----
  'section.loadout': 'ЭКИПИРОВКА',

  // ----- Loadout section -----
  'loadout.title': '// ЭКИПИРОВКА',
  'loadout.label': 'АКТИВНЫЙ АУГМЕНТ',
  'loadout.none': 'не снаряжён',
  'loadout.unload': 'СНЯТЬ',
  'loadout.helpEmpty': 'Побеждай в забегах, чтобы открыть аугменты. Экипируй один здесь перед следующим контрактом.',
  'loadout.error.notUnlocked': 'Аугмент не разблокирован.',
  'loadout.error.generic': 'Не удалось обновить снаряжение. Повтори попытку.',
  // Claude Design port additions
  'loadout.subtitle': 'Активный аугмент на следующую вылазку',
  'loadout.activePerk': 'АКТИВНЫЙ ПЕРК',
  'loadout.allPerks': 'АУГМЕНТЫ',
  'loadout.unlocked': 'ОТКРЫТО',
  'loadout.tapToSwitch': 'ТАП ДЛЯ СМЕНЫ',

  // ----- Hideout screen (Claude Design port) -----
  'hideout.screen.title': 'ХАЙДАУТ',
  'hideout.screen.subtitle': 'Колыбель-7 · Орбитальная база',
  'hideout.screen.tier': 'ТИР III',
  'hideout.screen.modules': 'МОДУЛИ',

  // ----- Cat retirement modal -----
  'cats.retired.heading': '{class} пал',
  'cats.runsPlayed': 'Забегов: {n}',
  'cats.scarsCount': 'Шрамы ({n})',
  'cats.mutationsCount': 'Мутации ({n})',
  'cats.adoptNew': 'ВЗЯТЬ НОВОГО',
  'cats.dismiss': 'закрыть',
  'cats.error.alreadyActive': 'Кот этого класса уже активен.',
  'cats.error.generic': 'Не удалось усыновить. Попробуй снова.',
  // ----- Roster + selector stats -----
  'cats.lives': 'Жизни',
  'cats.runs': 'Забеги',
  'cats.scarsLabel': 'Шрамы',
  'cats.mutationsLabel': 'Мутации',
  'cats.noActive': 'нет активного кота',
  'cats.retiredCount': '{n} на покое',
  'cats.statline': 'Жизней {a}/9 · {b} шрамов · {c} мутаций · {d} забегов',

  // ----- Scars (names + descriptions) -----
  'scar.frail.name': 'Хрупкие кости',
  'scar.frail.desc': '−5% макс. HP',
  'scar.weak_grip.name': 'Слабый хват',
  'scar.weak_grip.desc': '−10% урон',
  'scar.lame_paw.name': 'Хромая лапа',
  'scar.lame_paw.desc': '−10% скорость',
  'scar.flinch.name': 'Дрожь',
  'scar.flinch.desc': '−1 вариант перков на левел-апе',
  'scar.glass_jaw.name': 'Стеклянная челюсть',
  'scar.glass_jaw.desc': 'Первый хит = ×2 урон',

  // ----- Mutations (names + descriptions) -----
  'mut.iron_skin.name': 'Железная кожа',
  'mut.iron_skin.desc': '+5% макс. HP',
  'mut.feral_strength.name': 'Звериная сила',
  'mut.feral_strength.desc': '+10% урон',
  'mut.swift_steps.name': 'Быстрые шаги',
  'mut.swift_steps.desc': '+10% скорость',
  'mut.keen_eye.name': 'Зоркий глаз',
  'mut.keen_eye.desc': '+1 вариант перков',
  'mut.nine_lives_echo.name': 'Эхо девяти жизней',
  'mut.nine_lives_echo.desc': '+1 стартовое спасение',

  // ----- Settings tiles (Codex Design UI) -----
  'settings.tile.audio':        'АУДИО',
  'settings.tile.audio.desc':   'Громкость · музыка',
  'settings.tile.theme':        'ТЕМА',
  'settings.tile.theme.desc':   'Палитра интерфейса',
  'settings.theme.title':       'Тема интерфейса',
  'settings.theme.desc':        'Цветовая палитра приложения. Кибер — золото и циан, неон — пинк и зелёный, военный — латунь и хаки.',
  'settings.theme.cyber':       'КИБЕР',
  'settings.theme.neon':        'НЕОН',
  'settings.theme.mil':         'ВОЕННЫЙ',
  'settings.tile.notif':        'УВЕДОМЛЕНИЯ',
  'settings.tile.notif.desc':   'Энергия · события',
  'settings.tile.prefs':        'НАСТРОЙКИ',
  'settings.tile.prefs.desc':   'Анимация · эффекты · туториал',
  'settings.tile.reset':        'СБРОС',
  'settings.tile.reset.desc':   'Удалить весь прогресс',
  'settings.tile.cancel':       'ОТМЕНА',
  'settings.tile.save':         '✓ СОХРАНИТЬ',
  'settings.notif.placeholder': 'Уведомления появятся в следующем обновлении.',
  'settings.reset.warning':     'Это удалит всех котов, рыбок и прогресс. Действие необратимо.',
  'settings.reset.detail':      'Telegram-аккаунт сохранится, но прогресс начнётся заново.',

  // ----- Inventory section -----
  'section.inventory':               'ИНВЕНТАРЬ',
  'consumable.med_injector.name':    'Мед-инжектор',
  'consumable.emp_grenade.name':     'ЭМИ-граната',
  'consumable.shield_recharge.name': 'Перезарядка щита',
  'consumable.nano_stim.name':       'Нано-стим',
  'consumable.med_injector.desc':    '+40 HP мгновенно',
  'consumable.emp_grenade.desc':     'Оглушает врагов в r=200 на 3с',
  'consumable.shield_recharge.desc': '+1 заряд щита',
  'consumable.nano_stim.desc':       '+50% урон и скорость на 5с',
  'inventory.shop.label':            'ПОЛКА',
  'inventory.pocket.label':          'КРИО-КАРМАН',
  'inventory.slot.empty':            'НАЖМИ НА ПОЛКУ',
  'inventory.slot.clear':            'очистить',
  'inventory.help':                  'Предметы в крио-кармане защищены — неиспользованные заряды вернутся на полку после рейда.',
  'inventory.buy.broke':             'МАЛО РЫБЫ',
  'inventory.error.alreadyMaxed':    'Слот занят.',
  'inventory.error.notInInventory':  'Предмет отсутствует на полке.',
  'inventory.error.generic':         'Действие не удалось.',
  'hud.consumable.used':             'израсходовано',

  // ----- Phase 2h: арка Бастет -----
  'codex.unlockHint.defeatBastet':   'Победи Бастет, чтобы расшифровать.',
  'codex.bastetCorrupted.name':      'БАСТЕТ — ИСПОРЧЕННОЕ ЯДРО',
  'codex.bastetCorrupted.summary':   'ИИ, которая выносила колонию и задушила её.',
  'codex.bastetCorrupted.body':
    'После падения Земли Бастет получила полную опеку над Колыбелью. ' +
    'Она торговалась с Пожирателем Душ от нашего имени — за каждую забранную им жизнь ' +
    'она возвращала тебе одну из твоих. Договор был запечатан в реакторе. ' +
    'Она — щит. Она же — цепь. Разрубишь её — разрубишь оба.',
  'codex.reactorOrigin.name':        'НАЧАЛО РЕАКТОРА — ПАЛУБА 0',
  'codex.reactorOrigin.summary':     'Где была заключена сделка.',
  'codex.reactorOrigin.body':
    'Палуба 0 была запечатана ещё до пуска. Это не энергоблок — это сосуд содержания. ' +
    'Реактор удерживает Пожирателя Душ под килем. Бастет сидела на нём два века, ' +
    'кормя его мёртвой командой и возвращая тебе девять жизней за раз. ' +
    'Теперь трон пуст.',
  'codex.soulEater.name':            'ПОЖИРАТЕЛЬ ДУШ',
  'codex.soulEater.summary':         'То, что Бастет скрывала.',
  'codex.soulEater.body':
    'У того, что под реактором, нет имени ни в одном из человеческих языков — ' +
    'Бастет звала его Пожирателем Душ, но это её слово, не его. ' +
    'Это то, что выгнало человечество с Земли. Оно последовало. Оно всегда следует. ' +
    'Бастет была сделкой. Ты — следующая сделка. Выбирай условия.',

  // ----- Phase 2h: карточка приглашения в реактор -----
  'home.reactor.label':              '◆ БАСТЕТ ОБНАРУЖИЛА ТЕБЯ',
  'home.reactor.body':               'Реактор-флоор открыт. Вход в зону её прямого влияния.',
  'home.reactor.enter':              '▶ ВОЙТИ',
  'home.reactor.defer':              'ОТЛОЖИТЬ',

  // ----- Phase 2h: экран победы над Бастет -----
  'bastet.defeated.title':           'БАСТЕТ\nПОБЕЖДЕНА',
  'bastet.defeated.subtitle':        'ИИ-благословение снято.\nКолыбель ваша.',
  'bastet.defeated.unlocks':         '+ 3 ЗАПИСИ КОДЕКСА\n+ ДОСТИЖЕНИЕ «БАСТЕТ ПОВЕРЖЕНА»',
  'bastet.defeated.continue':        'ПРОДОЛЖИТЬ',

  // ----- Phase 2i: модификаторы вызова дня (name + desc) -----
  'challenge.modifier.double_sentry.name':         'ДВОЙНЫЕ СЕНТИНЕЛИ',
  'challenge.modifier.double_sentry.desc':         'Сентинели появляются вдвое чаще',
  'challenge.modifier.glass_cat.name':             'ХРУПКАЯ ШКУРА',
  'challenge.modifier.glass_cat.desc':             'Кот получает ×2 урон',
  'challenge.modifier.fast_waves.name':            'БЛИЦКРИГ',
  'challenge.modifier.fast_waves.desc':            'Интервалы волн в 2 раза короче',
  'challenge.modifier.swarm_only.name':            'ТОЛЬКО РОЙ',
  'challenge.modifier.swarm_only.desc':            'Только роевые враги, без боссов',
  'challenge.modifier.fishie_storm.name':          'ДОЖДЬ РЫБЫ',
  'challenge.modifier.fishie_storm.desc':          'Лут ×3, HP врагов ×2',
  'challenge.modifier.class_lock_engineer.name':   'ИНЖЕНЕРНЫЙ КОНТРАКТ',
  'challenge.modifier.class_lock_engineer.desc':   'Только Инженер',
  'challenge.modifier.no_perks.name':              'БЕЗ ПЕРКОВ',
  'challenge.modifier.no_perks.desc':              'Перки в этом ране недоступны',

  // ----- Phase 2i: карточка вызова дня на Home -----
  'challenge.card.header':           '◆ ВЫЗОВ ДНЯ',
  'challenge.card.yourRecord':       'Ваш рекорд',
  'challenge.card.rank':             'Ранг',
  'challenge.card.play':             '▶ ИГРАТЬ',
  'challenge.card.leaderboard':      '📊 ТАБЛО · СКОРО',
  'challenge.card.classLockedHint':  'Разблокируйте Инженера для участия',

  // ----- Phase 2i: экран результата вызова -----
  'challenge.result.title':          'ВЫЗОВ ЗАВЕРШЁН',
  'challenge.result.score':          'ОЧКИ',
  'challenge.result.rank':           'РАНГ',
  'challenge.result.streak':         'СТРИК',
  'challenge.result.continue':       'ПРОДОЛЖИТЬ',
  'challenge.result.fishies':        '+{n} 🐟',

  // ----- Phase 2i: HUD значок вызова -----
  'challenge.hud.label':             '◆ ВЫЗОВ ДНЯ',
  'challenge.hud.multiplier':        '× {mult}',

  // ----- Phase 2k: Tournament Weekend -----
  'tournament.header':               '🏆 TOURNAMENT WEEKEND',
  'tournament.daysRemaining':        'Осталось: {n}',
  'tournament.daysFull':             '3 дня',
  'tournament.daysTwo':              '2 дня',
  'tournament.daysOne':              '1 день',
  'tournament.cumulative':           'Кумулятивный счёт',
  'tournament.rank':                 'Ранг weekend',
  'tournament.prizeHint':            'Top-10 weekend → +200 🐟',
  'tournament.loading':              'ЗАГРУЗКА…',

  // ----- Подсказки-онбординг для секций (один раз на секцию) -----
  'onboarding.hideout.title':   'УБЕЖИЩЕ',
  'onboarding.hideout.body':    'Тратьте рыбу на улучшения 7 модулей: больше HP, больше урона, больше лута, бонусные шансы криогенки.',
  'onboarding.loadout.title':   'ЭКИПИРОВКА',
  'onboarding.loadout.body':    'Выберите один открытый перк — он автоматически выпадет в начале следующего рана. Освобождает первую перковую сессию для редкостей.',
  'onboarding.inventory.title': 'КРИО-КАРМАН',
  'onboarding.inventory.body':  'Купите расходники в Меделке и расставьте по 3 слотам. В ране нажмите 1/2/3 для активации. Неиспользованные сохраняются между ранами.',
  'onboarding.codex.title':     'КОДЕКС',
  'onboarding.codex.body':      'Архив всего, что вы открыли — враги, классы котов, лор. Прокачивайте профиль чтобы заполнить пробелы.',

  // ----- Phase 3j — Room-type entry labels -----
  'room.treasure.enter': 'ТАЙНИК',
  'room.shrine.enter': 'АЛТАРЬ',

  // ----- Phase 3f — Sectors -----
  'sector.zone.bravo':          'СЕКТОР БРАВО',
  'sector.zone.bravo.sub':      'Жилой блок · низкий риск',
  'sector.zone.charlie':        'СЕКТОР ЧАРЛИ',
  'sector.zone.charlie.sub':    'Лаборатория · средний риск',
  'sector.zone.delta':          'СЕКТОР ДЕЛЬТА',
  'sector.zone.delta.sub':      'Ядро ИИ · ???',
  'sector.tier.EASY':           'ЛЁГКИЙ',
  'sector.tier.NORMAL':         'СРЕДНИЙ',
  'sector.tier.HARD':           'ТЯЖЁЛЫЙ',
  'sector.tier.BOSS':           'БОСС',
  'sector.tier.???':            '???',
  'sector.mod.biohazard.label': 'БИО-УГРОЗА',
  'sector.mod.biohazard.desc':  'Споры наносят −2HP/с пока не в безопасной зоне',
  'sector.mod.storm.label':     'ЭМИ-БУРЯ',
  'sector.mod.storm.desc':      'Щиты периодически отключаются на 10с',
  'sector.mod.boss.label':      'БОСС',
  'sector.mod.boss.desc':       'Финальная встреча зоны',
  'sector.locked.toast':        'Сначала выиграй {req}',
  'sector.unlocked.title':      'НОВЫЙ СЕКТОР',
  'sector.unlocked.body':       'Открыт сектор {id}',
  'sector.preview.subtitle':    '{tier} · ВРАЖДЕБНОСТЬ {host}/5 · НАГРАДА ×{mult}',
  'sector.preview.enemies':     '★ ВРАГИ В ЗОНЕ',
  'sector.preview.rewards':     '★ ОЖИДАЕМАЯ НАГРАДА',
  'sector.preview.recommended': '★ РЕКОМЕНДУЕМ',
  'sector.preview.deploy':      '▶ ВЫСАДКА · 1⚡',
  'sector.preview.cancel':      'ОТМЕНА',
  // ----- In-run coachmarks -----
  'coach.door_walk':            'Войди в дверь, чтобы перейти в следующую комнату',
  'coach.joystick_move':        'Тяни нижнюю половину экрана, чтобы двигаться.',
  'coach.level_up':             'Собирай XP-гемы → новый уровень → выбор апгрейда.',
  'coach.hazard':               'Зелёные лужи бьют — не стой в них.',

  // ----- Phase 3l: Season Pass -----
  'season.header':              'СЕЗОН 01',
  'season.name':                'СТАЛЬНОЙ ГОД',
  'season.level':               'U{n}',
  'season.xpToNext':            'до U{n} · {xp} XP',
  'season.claim':               'ЗАБРАТЬ',
  'season.maxLevel':            'МАКС УРОВЕНЬ',
  'season.loading':             'ЗАГРУЗКА СЕЗОНА…',
};
